import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth'

const config = {
    apiKey: "AIzaSyB9i_DaxakvgN-XjsXEDwDrpheXQ3iESPE",
    authDomain: "thechurchco-group-chat.firebaseapp.com",
    databaseURL: "https://thechurchco-group-chat.firebaseio.com",
    projectId: "thechurchco-group-chat",
    storageBucket: "thechurchco-group-chat.appspot.com",
    messagingSenderId: "647252085749",
    appId: "1:647252085749:web:aaa6b71a01139d14b66ebc",
    measurementId: "G-3KSPXRX964"
 };

 // Init
firebase.initializeApp(config);
firebase.firestore().settings({})

export default firebase;